import { render } from "./LabelDropdown.vue?vue&type=template&id=8a701bca"
import script from "./LabelDropdown.vue?vue&type=script&lang=js"
export * from "./LabelDropdown.vue?vue&type=script&lang=js"

import "../styles/LabelDropdown.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__